export const getDefaultMealItem = () => ({
  name: '',
  quantity: 1,
  price: 0,
  cost: 0,
  note: '',
  surcharges: [],
});

export const getSampleOrder = (props = {}) => {
  const {
    elderId,
    noteForDelivery = '',
    noteForMeal = '',
    note,
    paymentMethod = 'PAID',
    deliveryGroupId,
    deliveryGroupSortOrder,
  } = props;
  return {
    elderId,
    noteForDelivery,
    noteForMeal,
    note,
    paymentMethod,
    deliveryGroupId,
    deliveryGroupSortOrder,
    mealItemName: '',
    mealItemQuantity: 1,
    mealItemPrice: 0,
    mealItemCost: 0,
    mealItemNote: '',
    mealItems: [getDefaultMealItem()],
  };
};
